import { Component, Input } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { TegelModule } from '@scania/tegel-angular-17';

@Component({
  selector: 'app-modal-confirmation',
  imports: [TegelModule],
  templateUrl: './modal-confirmation.component.html',
  styleUrl: './modal-confirmation.component.scss',
})
export class ModalConfirmationComponent {
  @Input() title = '';
  @Input() text = '';
  @Input() confirmText = '';
  @Input() confirmVariant = '';
  @Input() cancelText = '';
  @Input() cancelVariant = '';

  constructor(public dialogRef: MatDialogRef<ModalConfirmationComponent>) {}

  action(action: boolean) {
    this.dialogRef.close(action);
  }
}
